module.exports = {
    /* Supported Extensions */
    srcExt: ["asc","ass","cap","ccprj","csv","dfxp","docx","itt","mcc","pac","rtf","sami","sbv","scc","smi","srt","ssa","stl","sub","ttml","txt","vnl","vtt","webvtt","xml","890"],
    trgExt: ["asc","ass","ccprj","csv","dfxp","docx","itt","json","mcc","sami","sbv","scc","smi","srt","ssa","stl","sub","ttml","txt","vnl","vtt","webvtt","xml","890"],
    srcProfiles: {
        "890" : ["Cavena 890"],
        "itt": ["iTunes Timed Text"],
        "ccprj" : ["Closed Caption Project"],
        "docx" : ["LMS Transcript"],
        "ssa": ["Substation Alpha"],
        "ass": ["Advanced Substation Alpha"],
        "scc": ["Scenarist V1.0"],
        "mcc": ["MacCaption 608/708"],
        "rtf" : ["Rich Text Format Custom 01"],
        "srt": ["SubRip Video Subtitle Script"],
        "vtt": ["WebVTT"],
        "webvtt": ["WebVTT"],
        "sbv": ["SubViewer"],
        "sub": [
            "SubViewer", "Sofni", "Micro DVD", "DVD Architect"
        ],
        "txt": [
            "Avid DS",
            "Adobe Encore",
            "Apple DVD Studio Pro",
            "EZ Title",
            "PowerPixel Format",
            "ProCap Transfer",
            "QuickTime Text",
            "Eclipse"            
        ],
        "stl": [
            "EBU STL", "Spruce STL"
        ],
        "pac": ["ScreenSystems Poliscript"],
        "cap": ["Cheetah (binary)", "Videotron Lambda", "NCI Caption"],
        "asc": ["Cheetah (ASCII Text)"],
        "xml": [
            "Timed-Text Markup Language",
            "Distribution Format Exchange Profile (DFXP)",
            "DLP Cinema",
            "Netflix TT Captions",
            "Netflix TT Subtitles",
            "MAGIC TT",
            "EBU TT",
            "SMPTE TTML",
            "IMSC Text Captions",
            "IMSC Text Subtitles"
        ],
        "ttml": [
            "Timed-Text Markup Language",
            "Verizon TTML",
            "SMPTE TTML",
            "IMSC Text Captions",
            "IMSC Text Subtitles"
        ],
        "dfxp": ["Distribution Format Exchange Profile (DFXP)", "Timed-Text Markup Language", "Netflix DFXP"],
        "smi": ["Synchronized Accessible Media Interchange"],
        "csv": ["Comma-Separated Values"],
        "json": ["Google Speech-to-Text", "Assembly AI", "Deepgram", "Rev AI", "Voicegain", "Speechmatics"],
        "sami": ["Synchronized Accessible Media Interchange"],
        "vnl" : ["Vitac"]
    },
    trgProfiles: {
        "890" : ["Cavena 890"],
        "ccprj" : ["Closed Caption Project"],
        "docx" : ["LMS Transcript"],
        "itt": ["iTunes Timed Text"],
        "scc": ["Scenarist V1.0"],
        "ssa": ["Substation Alpha"],
        "ass": ["Advanced Substation Alpha"],
        "mcc": ["MacCaption 608/708"],
        "srt": ["SubRip Video Subtitle Script"],
        "vtt": ["WebVTT"],
        "webvtt": ["WebVTT"],
        "sbv": ["SubViewer"],
        "sub": [
            "SubViewer", "Sofni", "Micro DVD", "DVD Architect"
        ],
        "txt": [
            "Avid DS",
            "Adobe Encore",
            "Apple DVD Studio Pro",
            "EZ Title",
            "ProCap Transfer",
            "PowerPixel Format",
            "QuickTime Text",
            "Eclipse"
        ],
        "stl": [
            "EBU STL","Spruce STL"
        ],
        "asc": ["Cheetah (ASCII Text)"],
        "xml": [
            "Timed-Text Markup Language",
            "Distribution Format Exchange Profile (DFXP)",
            "DLP Cinema",
            "Netflix TT Captions",
            "Netflix TT Subtitles",
            "MAGIC TT",
            "EBU TT",
            "HBO GO TTML",
            "HBO MAX SMPTE",
            "HBO SMPTE TTML",
            "TTML Legacy",
            "SMPTE TTML",
            "FCP XML",
            "IMSC Text Captions",
            "IMSC Text Subtitles",
            "IMSC Text Captions - JA"        
        ],
        "ttml": [
            "Timed-Text Markup Language",
            "Verizon TTML",
            "HBO GO TTML",
            "HBO MAX SMPTE",
            "HBO SMPTE TTML",
            "TTML Legacy",
            "SMPTE TTML",
            "IMSC Text Captions",
            "IMSC Text Subtitles",
            "IMSC Text Captions - JA"
        ],
        "dfxp": ["Distribution Format Exchange Profile (DFXP)", "Netflix DFXP"],
        "smi": ["Synchronized Accessible Media Interchange"],
        "sami": ["Synchronized Accessible Media Interchange"],
        "csv": ["Comma-Separated Values"],
        "json": ["JSON"],
        "vnl" : ["Vitac"]
    },

    profileMapping: {    
        "LMS Transcript" : {
            name : "lmsTranscript",
            options : {
                decode : [],
                encode : []
            }
        },    
        "Closed Caption Project" : {
            name : "closedCaptionProject",
            options : {
                decode : [],
                encode : []
            }
        },
        "iTunes Timed Text" : {
            name : "iTunesTimedText",
            options : {
                decode : [],
                encode : [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en-US"
                    }
                ]
            }
        },
        "Google Speech-to-Text" : {
            name : "googleStt",
            options : {
                decode : [
                    {
                        name: "Import Type",
                        type: "list",
                        values: ["subtitle", "transcription", "word map"],
                        selected: "subtitle"
                    },
                    {
                        name: "Max Characters",
                        type: "number-input",
                        values: "",
                        selected: 32
                    },
                    {
                        name: "Max Lines",
                        type: "number-input",
                        values: "",
                        selected: 3
                    }
                ],
                encode : []
            }
        },
        "Assembly AI" : {
            name : "assemblyAi",
            options : {
                decode : [
                    {
                        name: "Import Type",
                        type: "list",
                        values: ["subtitle", "transcription", "word map"],
                        selected: "subtitle"
                    },
                    {
                        name: "Max Characters",
                        type: "number-input",
                        values: "",
                        selected: 32
                    },
                    {
                        name: "Max Lines",
                        type: "number-input",
                        values: "",
                        selected: 3
                    }  
                ],
                encode : []
            }
        },
        "Voicegain" : {
            name : "voicegain",
            options : {
                decode : [
                    {
                        name: "Import Type",
                        type: "list",
                        values: ["subtitle", "transcription", "word map"],
                        selected: "subtitle"
                    },
                    {
                        name: "Max Characters",
                        type: "number-input",
                        values: "",
                        selected: 32
                    },
                    {
                        name: "Max Lines",
                        type: "number-input",
                        values: "",
                        selected: 3
                    }   
                ],
                encode : []
            }
        },
        "Speechmatics" : {
            name : "speechmatics",
            options : {
                decode : [
                    {
                        name: "Import Type",
                        type: "list",
                        values: ["subtitle", "transcription", "word map"],
                        selected: "subtitle"
                    },
                    {
                        name: "Max Characters",
                        type: "number-input",
                        values: "",
                        selected: 32
                    },
                    {
                        name: "Max Lines",
                        type: "number-input",
                        values: "",
                        selected: 3
                    }   
                ],
                encode : []
            }
        },
        "Deepgram" : {
            name : "deepgram",
            options : {
                decode : [
                    {
                        name: "Import Type",
                        type: "list",
                        values: ["subtitle", "transcription", "word map"],
                        selected: "subtitle"
                    },
                    {
                        name: "Max Characters",
                        type: "number-input",
                        values: "",
                        selected: 32
                    },
                    {
                        name: "Max Lines",
                        type: "number-input",
                        values: "",
                        selected: 3
                    }   
                ],
                encode : []
            }
        },
        "Rev AI" : {
            name : "revAi",
            options : {
                decode : [
                    {
                        name: "Import Type",
                        type: "list",
                        values: ["subtitle", "transcription", "word map"],
                        selected: "subtitle"
                    },
                    {
                        name: "Max Characters",
                        type: "number-input",
                        values: "",
                        selected: 32
                    },
                    {
                        name: "Max Lines",
                        type: "number-input",
                        values: "",
                        selected: 3
                    }  
                ],
                encode : []
            }
        },
        "Vitac" : {
            name : "vitac",
            options : {
                decode: [],
                encode: [
                    {
                        name: "Title",
                        type: "text-input",
                        values: "",
                        selected: "Untitled"
                    }
                ]
            }
        },
        "FCP XML": {
            name: "fcpXml",
            /* Encode/Decode Options */
            options: {
                decode: [],
                encode: [
                    {
                        name: "Project Name",
                        type: "text-input",
                        values: "",
                        selected: "Untitled"
                    },
                    {
                        name: "File Extension",
                        type: "text-input",
                        values: "",
                        selected: "wav"
                    }
                ]
            },
        },
        "QuickTime Text": {
            name: "quickTimeText",
            options: {
                decode: [],
                encode: []
            },
        },
        "Micro DVD": {
            name: "uDvd",
            options: {
                decode: [],
                encode: []
            },
        },
        "HBO GO TTML": {
            name: "hboGoTtml",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "proportionalSansSerif"
                    }, 
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "16"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "transparent"
                    },  

                    {
                        name: "Line Height",
                        type: "text-input",
                        values: "",
                        selected: "125"
                    },
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "ms"
                    }           
                ]
            },
        },
        "HBO MAX SMPTE": {
            name: "hboMaxSmpte",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "monospace"
                    }, 
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "80"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "black"
                    },  
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "smpte"
                    }           
                ]
            },
        },
        "HBO SMPTE TTML": {
            name: "hboSmpteTtml",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "es"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "monospace"
                    }, 
                    {
                        name: "Line Height",
                        type: "text-input",
                        values: "",
                        selected: "8"
                    },
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "8"
                    },
                    {
                        name: "Font Weight",
                        type: "text-input",
                        values: "",
                        selected: "bold"
                    },  
                    {
                        name: "Outline Color",
                        type: "text-input",
                        values: "",
                        selected: "black"
                    },  
                    {
                        name: "Outline Vertical Size",
                        type: "number-input",
                        values: "",
                        selected: "5"
                    },
                    {
                        name: "Outline Horizontal Size",
                        type: "number-input",
                        values: "",
                        selected: "3"
                    },                       
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "ms"
                    }           
                ]
            },
        },
        "TTML Legacy": {
            name: "ttmlLegacy",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "proportionalSansSerif"
                    }, 
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "80"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "transparent"
                    },  

                    {
                        name: "Line Height",
                        type: "text-input",
                        values: "",
                        selected: "125"
                    },
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "ms"
                    }           
                ]
            },
        },
        "IMSC Text Captions - JA" : {
            name : "imscTextCaptionsJa",
            options : {
                decode : [],
                encode: [
                    {
                        name: "Version",
                        type: "list",
                        values: ["1.0", "1.1"],
                        selected: "1.1"
                    },
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "ja"
                    },
                    {
                        name: "Aspect Ratio",
                        type: "list",
                        values: ["4:3", "16:9"],
                        selected: "4:3"
                    },
                    {
                        name: "Program Name",
                        type: "text-input",
                        values: "",
                        selected: "Untitled"
                    },
                    {
                        name: "Program Description",
                        type: "text-input",
                        values: "",
                        selected: "Create by CC Converter 3"
                    },
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "proportionalSansSerif"
                    }, 
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "80"
                    },
                    {
                        name: "Line Height",
                        type: "number-input",
                        values: "",
                        selected: "100"
                    },
                    {
                        name: "Font Weight",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },
                    {
                        name: "Font Style",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "black"
                    },                      
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "ms"
                    }           
                ]
            }
        },
        "IMSC Text Captions" : {
            name : "imscTextCaptions",
            options : {
                decode : [],
                encode: [
                    {
                        name: "Version",
                        type: "list",
                        values: ["1.0", "1.1"],
                        selected: "1.0"
                    },
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Aspect Ratio",
                        type: "list",
                        values: ["4:3", "16:9"],
                        selected: "4:3"
                    },
                    {
                        name: "Program Name",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "monospaceSerif"
                    }, 
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "80"
                    },
                    {
                        name: "Line Height",
                        type: "number-input",
                        values: "",
                        selected: "100"
                    },
                    {
                        name: "Font Weight",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },
                    {
                        name: "Font Style",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "black"
                    },                      
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "smpte"
                    }           
                ]
            }
        },
        "IMSC Text Subtitles" : {
            name : "imscTextSubtitles",
            options : {
                decode : [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Extent X",
                        type: "number-input",
                        values: "",
                        selected: "720"
                    },
                    {
                        name: "Extent Y",
                        type: "number-input",
                        values: "",
                        selected: "480"
                    },
                    {
                        name: "Aspect Ratio",
                        type: "list",
                        values: ["4:3", "16:9"],
                        selected: "4:3"
                    },
                    {
                        name: "Program Name",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "monospaceSerif"
                    }, 
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "80"
                    },
                    {
                        name: "Line Height",
                        type: "number-input",
                        values: "",
                        selected: "100"
                    },
                    {
                        name: "Font Style",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "black"
                    },                      
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "smpte"
                    }           
                ]
            }
        },
        "SMPTE TTML": {
            name: "smpteTtml",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "monospace"
                    }, 
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: "80"
                    },
                    {
                        name: "Font Weight",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "black"
                    },                      
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "smpte"
                    }           
                ]
            },
        },
        "Substation Alpha": {
            name: "subStationAlpha",
            options: {
                decode: [],
                encode: []
            },
        },
        "Advanced Substation Alpha": {
            name: "subStationAlpha",
            options: {
                encode: [
                    {
                        name: "Font Family",
                        type: "list",
                        values: ["serif", "sans-serif", "monospace", "cursive", "fantasy", "Arial", "Verdana", "Helvetica", "Tahoma", "Trebuchet MS", "Times New Roman", "Georgia", "Garamond", "Courier New", "Brush Script MT"],
                        selected: "monospace"
                    },
                    {
                        name: "Font Size",
                        type: "number-input",
                        values: "",
                        selected: 24
                    },
                    {
                        name: "Line Height",
                        type: "number-input",
                        values: "",
                        selected: 22
                    },
                    {
                        name: "Spacing",
                        type: "number-input",
                        values: "",
                        selected: 10
                    },
                    {
                        name: "Padding",
                        type: "number-input",
                        values: "",
                        selected: 7
                    },
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "#ffffff"
                    },
                    {
                        name: "Opacity",
                        type: "number-input",
                        values: "",
                        selected: 100
                    },
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "#000000"
                    },
                    {
                        name: "Background Opacity",
                        type: "number-input",
                        values: "",
                        selected: "100"
                    },
                    {
                        name: "Outline Color",
                        type: "text-input",
                        values: "",
                        selected: "#000000"
                    },
                    {
                        name: "Outline Opacity",
                        type: "number-input",
                        values: "",
                        selected: "100"
                    },
                    {
                        name: "Outline Size (px)",
                        type: "number-input",
                        values: "",
                        selected: "0"
                    },
                    {
                        name: "Shadow Size (px)",
                        type: "number-input",
                        values: "",
                        selected: "0"
                    },
                    {
                        name: "ScaleX",
                        type: "number-input",
                        values: "",
                        selected: 100
                    },
                    {
                        name: "ScaleY",
                        type: "number-input",
                        values: "",
                        selected: 100
                    },
                    {
                        name: "Video Width",
                        type: "number-input",
                        values: "",
                        selected: 1280
                    },
                    {
                        name: "Video Height",
                        type: "number-input",
                        values: "",
                        selected: 720
                    }
                ],
                decode: []
            }
        },
        "Adobe Encore": {
            options: {
                decode: [],
                encode: []
            },
            name: "adobeEncore"
        },
        "Apple DVD Studio Pro": {
            options: {
                decode: [],
                encode: []
            },
            name: "appleDvdStudioPro"
        },
        "Avid DS": {
            options: {
                decode: [],
                encode: []
            },
            name: "avidDs"
        },
        "Cheetah (ASCII Text)": {
            options: {
                decode: [],
                encode: []
            },
            name: "cheetahAscii"
        },
        "Cheetah (binary)": {
            options: {
                decode: [],
                encode: []
            },
            name: "cheetahBin"
        },
        "Videotron Lambda" : {
            options: {
                decode: [],
                encode: []
            },
            name: "videotronLambda"
        },
        "NCI Caption" : {
            options: {
                decode: [],
                encode: []
            },
            name: "nciCaption"
        },
        "Distribution Format Exchange Profile (DFXP)": {
            options: {
                decode: [],
                encode: []
            },
            name: "dfxp"
        },
        "Netflix DFXP": {
            options: {
                decode: [],
                encode: []
            },
            name: "netflixDfxp"
        },
        "DLP Cinema": {
            options: {
                decode: [],
                encode: [
                    {
                        name: "Title",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Reel Number",
                        type: "number-input",
                        values: "",
                        selected: "1"
                    },
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Fade Up Time",
                        type: "number-input",
                        values: "",
                        selected: "20"
                    },
                    {
                        name: "Fade Down Time",
                        type: "number-input",
                        values: "",
                        selected: "20"
                    },
                    {
                        name: "Vertical Position Start",
                        type: "number-input",
                        values: "",
                        selected: "10"
                    },
                    {
                        name: "Vertical Spacing",
                        type: "number-input",
                        values: "",
                        selected: "6"
                    },
                ]
            },
            name: "dlpCinema"
        },
        "DVD Architect": {
            options: {
                decode: [],
                encode: []
            },
            name: "dvdArch"
        },
        "EBU STL": {
            options: {
                decode: [
                    {
                        name: "Decode Speakers By Color",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Speaker Identifier",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Insert Speaker Identifier",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Speaker Is Greater Than",
                        type: "number-input",
                        values: "",
                        selected: 1
                    },
                ],
                encode: [
                    {
                        name: "Display Standard Code",
                        type: "list",
                        values: ["Undefined", "Open subtitling", "Level-1 teletext", "Level-2 teletext"],
                        selected: "Open subtitling"
                    },
                    {
                        name: "Program Title",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Episode Title",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Translated Program Title",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Translated Episode Title",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Translator's Name",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Translator's Contact Details",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Subtitle List Ref Code",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Publisher",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Editor's Name",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Editor's Contact Details",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "GSI Character Set",
                        type: "list",
                        values: ["United States", "Multilingual", "Portuguese", "Canada-French", "Nordic"],
                        selected: "Multilingual"
                    },
                    {
                        name: "Character Code Table",
                        type: "list",
                        values: ["Latin", "Cyrillic", "Arabic", "Greek", "Hebrew"],
                        selected: "Latin"
                    },
                    {
                        name: "SOM",
                        type: "text-input",
                        values: "00:00:00:00",
                        selected: "00:00:00:00"
                    },
                ]
            },
            name: "ebuStl"
        },
        "EBU TT": {
            options: {
                decode: [],
                encode: []
            },
            name: "ebuTt"
        },
        "Eclipse" : {
            options : {
                decode : [],
                encode : []
            },
            name : "eclipse"
        },
        "EZ Title": {
            options: {
                decode: [],
                encode: []
            },
            name: "ezTitle"
        },
        "MacCaption 608/708": {
            options: {
                decode: [
                    {
                        name: "Caption Standard",
                        type: "list",
                        values: ["608", "708"],
                        selected: "608"
                    }
                ],
                encode: [
                    {
                        name: "Channel",
                        type: "list",
                        values: ["ch01", "ch02", "ch03", "ch04"],
                        selected: "ch01"
                    },
                    {
                        name: "MCC Version",
                        type: "list",
                        values: ["2.0", "1.0"],
                        selected: "2.0"
                    }
                ]
            },
            name: "macCaption"
        },
        "MAGIC TT": {
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Title",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Description",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                ]
            },
            name: "magicTt"
        },
        "Netflix TT Captions": {
            options: {
                decode: [],
                encode: []
            },
            name: "netflixTtCaptions"
        },
        "Netflix TT Subtitles": {
            options: {
                decode: [],
                encode: []
            },
            name: "netflixTtSubtitles"
        },

        "PowerPixel Format": {
            options: {
                decode: [],
                encode: []
            },
            name: "powerPixel"
        },
        "ProCap Transfer": {
            options: {
                decode: [],
                encode: [
                    {
                        name: "Title",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Author",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Owner",
                        type: "text-input",
                        values: "",
                        selected: ""
                    }
                ]
            },
            name: "proCapTransfer"
        },
        "Synchronized Accessible Media Interchange": {
            options: {
                decode: [],
                encode: []
            },
            name: "sami"
        },
        "Scenarist V1.0": {
            name: "scenerist",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Channel",
                        type: "list",
                        values: ["ch01", "ch02", "ch03", "ch04"],
                        selected: "ch01"
                    },
                    {
                        name: "Line Endings",
                        type: "list",
                        values: ["windows", "unix", "macintosh"],
                        selected: "unix"
                    },
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["colon", "semi-colon", "auto"],
                        selected: "auto"
                    },
                    {
                        name: "Incode",
                        type: "text-input",
                        values: "",
                        selected: ""
                    },
                ]
            }
        },
        "Spruce STL": {
            options: {
                decode: [],
                encode: []
            },
            name: "spruceStl"
        },
        "Cavena 890" : {
            name : "cavena890",
            options : {
                decode : [],
                encode : []
            }
        },
        "ScreenSystems Poliscript": {
            options: {
                decode: [
                    {
                        name: "Code Page",
                        type: "list",
                        values: [
                            "ISO 8859-1 Latin 1",
                            "ISO 8859-2 Latin 2",
                            "ISO 8859-3 Latin 3",
                            "ISO 8859-4 Baltic",
                            "ISO 8859-5 Cyrillic",
                            "ISO 8859-6 Arabic",
                            "ISO 8859-7 Greek",
                            "ISO 8859-8 Hebrew",
                            "ISO 8859-9 Turkish"                            
                        ],
                        selected: "ISO 8859-1 Latin 1"
                    },
                    {
                        name: "Ignore Metadata",
                        type: "list",
                        values: [true, false],
                        selected: true
                    }
                ],
                encode: []
            },
            name: "ssPoliscript"
        },
        "Rich Text Format Custom 01" : {
            options: {
                decode: [],
                encode: []
            },
            name: "rtf_custom_01"
        },
        "SubRip Video Subtitle Script": {
            timecode: "ms",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Encode Formatting",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                ]
            },
            name: "subRip"
        },
        "SubViewer": {
            options: {
                decode: [],
                encode: []
            },
            name: "subViewer"
        },
        "Sofni": {
            options: {
                decode: [],
                encode: []
            },
            name: "sofni"
        },
        "Timed-Text Markup Language": {
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },        
                    {
                        name: "Font Color",
                        type: "text-input",
                        values: "",
                        selected: "white"
                    },     
                    {
                        name: "Background Color",
                        type: "text-input",
                        values: "",
                        selected: "black"
                    },  
                    {
                        name: "Font Family",
                        type: "text-input",
                        values: "",
                        selected: "monospace"
                    }, 
                    {
                        name: "Font Size (%)",
                        type: "number-input",
                        values: "",
                        selected: "80"
                    },
                    {
                        name: "Font Weight",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },  
                    {
                        name: "Font Style",
                        type: "text-input",
                        values: "",
                        selected: "normal"
                    },                  
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "smpte"
                    },     
                ]
            },
            name: "ttml"
        },
        "Verizon TTML" : {
            options: {
                decode: [],
                encode: [
                    {
                        name: "Language Code",
                        type: "text-input",
                        values: "",
                        selected: "en"
                    },
                    {
                        name: "Line Height",
                        type: "number-input",
                        values: "",
                        selected: 5.33
                    },
                    {
                        name: "Timecode Format",
                        type: "list",
                        values: ["smpte", "ms"],
                        selected: "smpte"
                    },     
                    {
                        name: "608 Format",
                        type: "list",
                        values: ["yes", "no"],
                        selected: "no"
                    }
                ]
            },
            name: "ttmlVerizon"
        },
        "WebVTT": {
            timecode: "ms",
            options: {
                decode: [],
                encode: [
                    {
                        name: "Encode Id",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Position Template",
                        type: "list",
                        values: ["Default", "Standard", "YouTube", "MUFI","Custom01"],
                        selected: "Default"
                    },
                    {
                        name: "Encode Position",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Encode Formatting",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Encode Font Styles",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Encode Metadata Notes",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Metadata Notes",
                        type: "textarea",
                        values: "",
                        selected: ""
                    },
                    {
                        name: "Use HTML Tags",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Override Font Color",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Override Background Color",
                        type: "list",
                        values: [true, false],
                        selected: false
                    },
                    {
                        name: "Font Color",
                        type: "list",
                        values: ["white", "lime", "cyan", "red", "yellow", "magenta", "blue", "black"],
                        selected: "white"
                    },  
                    {
                        name: "Background Color",
                        type: "list",
                        values: ["white", "lime", "cyan", "red", "yellow", "magenta", "blue", "black"],
                        selected: "black"
                    },
                    {
                        name: "Max Characters Per Line",
                        type: "number-input",
                        values: "",
                        selected: 40
                    }
                ]
            },
            name: "webVtt"
        },
        "Comma-Separated Values": {
            options: {
                decode: [
                    {
                        name: "Start Time",
                        type: "list",
                        values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
                        selected: "A"

                    },
                    {
                        name: "End Time",
                        type: "list",
                        values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
                        selected: "B"
                    },
                    {
                        name: "Text",
                        type: "list",
                        values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
                        selected: "C"
                    },
                    {
                        name: "Start Time Format",
                        type: "list",
                        values: ["SMPTE Timecode (HH:MM:SS:FF)", "MS Timecode (HH:MM:SS.MSS)", "Seconds (SS)", "Timecode (HH:MM:SS)"],
                        selected: "SMPTE Timecode (HH:MM:SS:FF)"

                    },
                    {
                        name: "End Time Format",
                        type: "list",
                        values: ["SMPTE Timecode (HH:MM:SS:FF)", "MS Timecode (HH:MM:SS.MSS)", "Seconds (SS)", "Timecode (HH:MM:SS)"],
                        selected: "SMPTE Timecode (HH:MM:SS:FF)"

                    },
                ],
                encode: [

                ]
            },
            name: "csv"
        },
        "JSON": {
            options: {
                decode: [],
                encode: []
            },
            name: "json"
        }
    },
    binaryFormats: [
        "cheetahBin", "ebuStl", "ssPoliscript", "cavena890", "nciCaption"
    ],
    defaultEncodingMap: {
        "lmsTranscript" : "buffer",
        "closedCaptionProject" : "utf-8",
        "iTunesTimedText" : "utf-8", 
        "googleStt" : "utf-8",
        "voicegain" : "utf-8",
        "speechmatics" : "utf-8",
        "deepgram" : "utf-8",
        "revAi" : "utf-8",
        "assemblyAi" : "utf-8",
        "vitac" : "utf-8",
        "subStationAlpha": "utf-8",
        "uDvd": "utf-8",
        "quickTimeText": "utf-8",
        "adobeEncore": "utf-8",
        "appleDvdStudioPro": "utf-8",
        "avidDs": "utf-16le",
        "videotronLambda" : "shift-jis", 
        "nciCaption" : "hex",
        "cheetahBin": "hex",
        "cavena890" : "hex",
        "cheetahAscii": "utf-8",
        "eclipse" : "utf-8",
        "dfxp": "utf-8",
        "dlpCinema": "utf-8",
        "dvdArch": "utf-16le",
        "ebuStl": "hex",
        "ebuTt": "utf-8",
        "ezTitle": "utf-8",
        "macCaption": "utf-8",
        "magicTt": "utf-8",
        "netflixTtCaptions": "utf-8",
        "netflixTtSubtitles": "utf-8",
        "netflixDfxp": "utf-8",
        "powerPixel": "utf-8",
        "proCapTransfer": "latin1",
        "sami": "utf-8",
        "scenerist": "utf-8",
        "sofni": "utf-8",
        "spruceStl": "utf-8",
        "ssPoliscript": "hex",
        "rtf_custom_01" : "utf-8",
        "subRip": "utf-8",
        "subViewer": "utf-8",
        "ttml": "utf-8",
        "ttmlVerizon" : "utf-8",
        "imscTextCaptionsJa" : "utf-8",
        "imscTextCaptions" : "utf-8",
        "imscTextSubtitles" : "utf-8",
        "hboGoTtml" : "utf-8",
        "hboMaxSmpte" : "utf-8",
        "ttmlLegacy" : "utf-8",
        "hboSmpteTtml" : "utf-8",
        "smpteTtml" : "utf-8",
        "webVtt": "utf-8",
        "json": "utf-8",
        "csv": "utf-8"
    },
    defaultExtMap: {
        "lmsTranscript" : "docx",
        "cavena890" : "890",        
        "closedCaptionProject" : "ccprj",
        "iTunesTimedText" : "itt",
        "voicegain" : "json",
        "speechmatics" : "json",
        "googleStt" : "json",
        "deepgram" : "json",
        "revAi" : "json",
        "assemblyAi" : "json",
        "vitac" : "vnl",
        "subStationAlpha": "aas",
        "uDvd": "sub",
        "quickTimeText": "txt",
        "adobeEncore": "txt",
        "appleDvdStudioPro": "txt",
        "eclipse" : "txt",
        "avidDs": "txt",
        "cheetahBin": "cap",
        "videotronLambda" : "cap",
        "nciCaption" : "cap",
        "cheetahAscii": "asc",
        "dfxp": "dfxp",
        "dlpCinema": "xml",
        "dvdArch": "sub",
        "ebuStl": "stl",
        "ebuTt": "xml",
        "ezTitle": "txt",
        "macCaption": "mcc",
        "magicTt": "xml",
        "netflixTtCaptions": "xml",
        "netflixTtSubtitles": "xml",
        "powerPixel": "txt",
        "proCapTransfer": "txt",
        "sami": "smi",
        "scenerist": "scc",
        "sofni": "sub",
        "spruceStl": "stl",
        "ssPoliscript": "pac",
        "rtf_custom_01" : "rtf",
        "subRip": "srt",
        "subViewer": "sub",
        "ttml": "ttml",
        "ttmlVerizon" : "ttml",
        "hboGoTtml" : "ttml",
        "hboMaxSmpte" : "xml",
        "ttmlLegacy" : "ttml",
        "hboSmpteTtml" : "ttml",
        "smpteTtml" : "ttml",
        "imscTextCaptionsJa" : "ttml",
        "imscTextCaptions" : "ttml",
        "imscTextSubtitles" : "ttml",
        "webVtt": "vtt",
        "json": "json",
        "csv": "csv"
    },
    getSrcProfileDisplayNames : function(){
        let profiles = [];
        for (let [key, values] of Object.entries(this.srcProfiles)) {
            values.forEach(value => {
                profiles.push(value);
            })
        }
        return [...new Set(profiles)]
    },
    getTrgProfileDisplayNames : function(){
        let profiles = [];
        for (let [key, values] of Object.entries(this.trgProfiles)) {
            values.forEach(value => {
                profiles.push(value);
            })
        }
        return [...new Set(profiles)]
    },

    getSrcProfiles: function () {
        let profiles = [];
        let profileMapping = this.profileMapping;
        for (let [key, values] of Object.entries(this.srcProfiles)) {
            values.forEach(value => {
                profiles.push(profileMapping[value].name);
            })
        }
        return [...new Set(profiles)]
    },
    getTrgProfiles: function () {
        let profiles = [];
        let profileMapping = this.profileMapping;
        for (let [key, values] of Object.entries(this.trgProfiles)) {
            values.forEach(value => {
                profiles.push(profileMapping[value].name);
            });
        }

        return [...new Set(profiles)]
    },

    getProfileTitleByName: function (name) {
        for (let [key, value] of Object.entries(this.profileMapping)) {
            if (this.profileMapping[key].name === name) {
                return key;
            }
        }

        return (new Error(name + " is not a supported format. Please check casing or contact support"));
    },
}
